import React from 'react';
import { useParams } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';
import { ConversationsList } from './ConversationsList';
import { ConversationDetail } from './ConversationDetail';
import { CreateConversation } from './CreateConversation';
import { useConversations } from '../../hooks/useConversations';
import { useTranslation } from '../../hooks/useTranslation';

export const Messages = () => {
  const { id } = useParams<{ id: string }>();
  const { fetchConversations } = useConversations();
  const { t, getPathForLang } = useTranslation();

  return (
    <div className="fixed inset-0 flex flex-col pt-16 pb-16 md:static md:pt-0 md:pb-0 md:h-[calc(100vh-8rem)]">
      <div className="flex-1 flex overflow-hidden">
        {/* Liste des conversations */}
        <div className={`${
          id === 'new' || id ? 'hidden md:block' : 'w-full'
        } md:w-80 flex-shrink-0 md:border-r md:border-gray-200 bg-white md:rounded-l-2xl overflow-y-auto`}>
          <ConversationsList />
        </div>

        {/* Colonne de droite */}
        <div className={`flex-1 ${!id && id !== 'new' ? 'hidden md:block' : 'w-full'} bg-white md:rounded-r-2xl overflow-hidden flex flex-col`}>
          {id === 'new' ? (
            <CreateConversation onConversationCreated={fetchConversations} />
          ) : id ? (
            <div className="h-full flex flex-col">
              <div className="flex-1 overflow-hidden">
                <ConversationDetail conversationId={id} />
              </div>
            </div>
          ) : (
            <div className="flex-1 flex items-center justify-center bg-gray-50 h-full md:rounded-r-2xl">
              <div className="text-center">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <MessageCircle className="w-8 h-8 text-gray-400" />
                </div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  {t('messages.your_messages')}
                </h3>
                <p className="text-gray-500 max-w-sm mx-auto px-4">
                  {t('messages.select_conversation')}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}; 